module.exports = __webpack_public_path__ + "static/img/200071.881fd2b9.png";